// Class names and inline styles shared by the immersive (full-screen, swipeable) feed and its
// slides.

// ── Control styling. The top-right Clone/Extend + ellipsis reuse the grid card's
// overlay styles (OVERLAY_PILL / OVERLAY_ICON) so the viewer matches the cards.
// Close/mute and the bottom action pills stay round + translucent.
// Matches the /generate fullscreen view's close button (ImageLightbox).
export const ROUND_BTN =
  'flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20'
export const ACTION_PILL =
  'inline-flex h-9 items-center gap-1.5 rounded-full bg-black/40 px-3.5 text-[13px] font-semibold text-white transition active:scale-95'
export const ACTION_ICON =
  'flex h-9 w-9 items-center justify-center rounded-full bg-black/40 text-white transition active:scale-95'

// Height-driven fit: capped at the page height (set as --feed-media-max), width
// derives from the artwork's aspect ratio. object-contain never crops — the whole
// clip always shows (portrait letterboxes, landscape fills the width).
export const FIT =
  'block h-auto w-auto max-w-full object-contain max-h-[var(--feed-media-max,100dvh)]'

// Offscreen pages skip layout + paint so a long feed stays smooth.
export const CV_STYLE = {
  contentVisibility: 'auto',
  containIntrinsicSize: 'auto var(--feed-media-max, 100dvh)',
}

// Generous edge insets so controls/text clear the notch, browser UI, rounded
// corners and any letterbox bars on portrait video — never riding the edge.
// Each combines the device safe-area inset with a comfortable base gap.
const EDGE = '1.15rem' // top-row controls
const BOTTOM_EDGE = '1.4rem' // bottom caption + actions (a touch more breathing room)
export const CLOSE_INSET = {
  top: `calc(env(safe-area-inset-top, 0px) + ${EDGE})`,
  left: `calc(env(safe-area-inset-left, 0px) + ${EDGE})`,
}
// Full-width wrapper for the top-right cluster: it's an `@container` so
// OVERLAY_PILL's `@[380px]:` label variants activate (the viewport is wide), and
// padding keeps the cluster off the edge/safe-area.
export const TOP_RIGHT_WRAP = {
  top: `calc(env(safe-area-inset-top, 0px) + ${EDGE})`,
  paddingLeft: `calc(env(safe-area-inset-left, 0px) + ${EDGE})`,
  paddingRight: `calc(env(safe-area-inset-right, 0px) + ${EDGE})`,
}
export const BOTTOM_INSET = {
  paddingLeft: `calc(env(safe-area-inset-left, 0px) + ${BOTTOM_EDGE})`,
  paddingRight: `calc(env(safe-area-inset-right, 0px) + ${BOTTOM_EDGE})`,
  paddingBottom: `calc(env(safe-area-inset-bottom, 0px) + ${BOTTOM_EDGE})`,
}
